import React from 'react';
import UnauthSection from '../Components/Unauthorized';

const UnauthorizedPage = () => (
  <UnauthSection />
);

export default UnauthorizedPage;
